<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <div>
    <h1>{{ t('textBlock.title') }}</h1>
    <div class="content" v-html="t('textBlock.content')"></div>
  </div>
</template>

<script>
export default {
  name: "DpImprint"
};
</script>

<i18n>
{}
</i18n>
